export const DEFAULT_ACTION = 'screen/NotificationScreen/DEFAULT_ACTION';
export const UPDATE_INPUT = 'screen/NotificationScreen/UPDATE_INPUT';

export const GET_NOTIFICATIONS = 'screen/NotificationScreen/GET_NOTIFICATIONS';
export const GET_NOTIFICATIONS_LOADING = 'screen/NotificationScreen/GET_NOTIFICATIONS_LOADING';
export const GET_NOTIFICATIONS_SUCCESS = 'screen/NotificationScreen/GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAIL = 'screen/NotificationScreen/GET_NOTIFICATIONS_FAIL';